import React from 'react';
import Modal2 from 'components/_shared/Modal2';
import MemberStatus from './components/MemberStatus';
import MemberDetails from 'components/holders_list/components/EligibilityComponents/MemberDetails';
import { CTAButton3 } from 'components/_shared/buttons';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { MemberSearchResult } from 'types';

const useStyles = makeStyles(() => ({
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '32px'
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '40px'
    },
    closeButton: {
        color: '#7378E8',
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'none !important'
    },
    btnDiv: {
        display: 'flex',
        justifyContent: 'center'
    }
}));

const iconStyle = {
    backgroundColor: '#E7EFFE',
    border: '2px solid #062D7A',
    color: '#062D7A',
    fontSize: '24px'
};

type ReinstatePopupProps = {
    member: MemberSearchResult;
    closeButtonText: string;
    handleCloseClick: () => void;
    handleReinstate: () => void;
};

const ReinstatePopup: React.FC<ReinstatePopupProps> = ({
    member,
    closeButtonText,
    handleCloseClick,
    handleReinstate
}) => {
    const classes = useStyles();

    const memberName = member?.pii_first_name && member?.pii_last_name ? `${member.pii_first_name} ${member.pii_last_name}` : member?.name || '-';
    return (
        <Modal2
            onClose={handleCloseClick}
            additionalStyles={{ iconStyle: iconStyle }}
            iconName=""
            title="Reinstate"
        >
            <div className={classes.body}>
                <MemberStatus
                    photo={member.photo}
                    icon="far fa-exclamation-circle"
                    title={`${memberName} has a closed membership`}
                    subtext={`${memberName} already has an inactive membership with Humana. Would you like to request an extension?`}
                    colorType="yellow"
                />
                <MemberDetails member={member} />
                <div className={classes.buttonContainer}>
                    <CTAButton3 onClick={handleReinstate}>
                        Request Extension
                    </CTAButton3>
                </div>
                <div className={classes.btnDiv}>
                    <Button className={classes.closeButton} onClick={handleCloseClick}>
                        {closeButtonText}
                    </Button>
                </div>
            </div>
        </Modal2>
    );
};

export default ReinstatePopup;
